<template>
    <div>
        <h5>User Details</h5>

        <form @submit.prevent="validate">
            <div class="form-group" v-if="registrationType === 4">
                <label>Full Name</label>
                <input type="text" name="fullName" data-vv-validate-on="blur" data-vv-as="full name"
                    placeholder="Full Name" v-model="value.name" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid': validationErrors.has('fullName')
                    }">
                <div v-show="validationErrors.has('fullName')" class="invalid-feedback">
                    {{ validationErrors.first('fullName') }}
                </div>
            </div>

            <div class="form-group">
                <label>Email Address</label>
                <input v-if="!emailReadonly" type="text" name="email" v-model="value.email"
                    v-validate="'required|email'" :class="{
                        'form-control': true,
                        'is-invalid': validationErrors.has('email')
                    }">
                <div v-else class="mb-2">
                    <b>{{ emailAddressDisplay }}</b>
                </div>
                <div v-show="validationErrors.has('email')" class="invalid-feedback">
                    {{ validationErrors.first('email') }}
                </div>
            </div>

            <div class="form-group required">
                <label>Password</label>

                <input type="password" name="password" data-vv-validate-on="blur" placeholder="Create a New Password"
                    v-model="value.password" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid': validationErrors.has('password')
                    }" ref="passwordRef">

                <div v-show="validationErrors.has('password')" class="invalid-feedback">
                    {{ validationErrors.first('password') }}
                </div>
            </div>

            <div class="form-group required">
                <label>Confirm Password</label>

                <input type="password" name="repeatPassword" data-vv-validate-on="blur" placeholder="Confirm your password"
                    v-model="value.repeatPassword" v-validate="'required|confirmed:passwordRef'" data-vv-as="password"
                    :class="{
                        'form-control': true,
                        'is-invalid': validationErrors.has('repeatPassword')
                    }">

                <div v-show="validationErrors.has('repeatPassword')" class="invalid-feedback">
                    {{ validationErrors.first('repeatPassword') }}
                </div>
            </div>

            <div class="form-group" v-if="registrationType !== 4 && registrationType !== 5">
                <label>Designation</label>
                <select name="designation" data-vv-validate-on="blur" data-vv-as="designation"
                    v-model="value.designationChoice" :class="{
                        'form-control': true,
                        'is-invalid': validationErrors.has('designation')
                    }">
                    <option v-for="(designation, index) in designations" :key="index" :value="designation.value">
                        {{ designation.text }}
                    </option>
                </select>

                <input v-if="value.designationChoice === -1" type="text" name="designationText" data-vv-validate-on="blur"
                    data-vv-as="designation" placeholder="Designation"
                    v-model="value.designation" v-validate="'required'"
                    :class="{
                        'form-control': true,
                        'is-invalid': validationErrors.has('designationText')
                    }">

                <div v-show="validationErrors.has('designation')" class="invalid-feedback">
                    {{ validationErrors.first('designation') }}
                </div>
            </div>

            <div class="form-group" v-if="registrationType !== 4 && registrationType !== 5">
                <label>Full Name (Must be exactly as appeared in IC)</label>
                <input type="text" name="fullName" data-vv-validate-on="blur" data-vv-as="full name" placeholder="Full Name" v-model="value.name" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid': validationErrors.has('fullName')
                    }">
                <div v-show="validationErrors.has('fullName')" class="invalid-feedback">
                    {{ validationErrors.first('fullName') }}
                </div>
            </div>

            <div class="form-group" v-if="registrationType !== 4 && registrationType !== 5">
                <label>Identification Type</label>
                <select name="identificationType" data-vv-validate-on="blur" data-vv-as="identification type"
                    v-validate="identificationTypeValidation" v-model="value.identificationType" :class="{
                        'form-control': true,
                        'is-invalid': validationErrors.has('identificationType')
                    }">
                    <option value="0">Please Select</option>
                    <option v-for="(identificationType, index) in identificationTypes" :key="index"
                        :value="identificationType.value">
                        {{ identificationType.text }}
                    </option>
                </select>
                <div v-show="validationErrors.has('identificationType')" class="invalid-feedback">
                    {{ validationErrors.first('identificationType') }}
                </div>
            </div>

            <!-- If identification type is new ICc -->
            <div class="form-group" v-if="registrationType !== 4 && registrationType !== 5">
                <label>Identification Number</label>
                <input type="text" name="identityNumber" data-vv-validate-on="blur" data-vv-as="identification number"
                    v-mask="value.identificationType === 1 ? '######-##-####' : null"
                    placeholder="Identification Number" v-model="value.identificationNumber" v-validate="'required'"
                    :class="{
                        'form-control': true,
                        'is-invalid': validationErrors.has('identityNumber')
                    }">
                <div v-show="validationErrors.has('identityNumber')" class="invalid-feedback">
                    {{ validationErrors.first('identityNumber') }}
                </div>
            </div>

            <div class="form-group required" v-if="registrationType !== 4">
                <label>Phone Number</label>
                <input type="text" name="mobileNumber" data-vv-validate-on="blur" data-vv-as="phone number"
                    placeholder="Phone Number" v-model="value.mobileNumber" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid': validationErrors.has('mobileNumber')
                    }">
                <div v-show="validationErrors.has('mobileNumber')" class="invalid-feedback">
                    {{ validationErrors.first('mobileNumber') }}
                </div>
            </div>

            <div class="form-group" v-if="registrationType === 1 || registrationType === 4">
                <label>Referral Code (optional)</label>
                <input type="text" name="referralCode" v-model="value.referralCode" :class="{
                    'form-control': true,
                }">
                <small class="form-text text-muted">If you were referred to us by a friend, colleague, or associate,
                    please enter their unique referral code in the field above. </small>
            </div>

            <div v-if="false" class="card">
                <div class="card-body">
                    <p>Are you an existing Alliance Bank customer? Verify your identity and enjoy exclusive discounts by
                        entering the first 6 digits of your credit/debit card number in the textbox below.
                    </p>
                    <p>
                        Rest assured, this information will only be used to verify your relationship with Alliance Bank,
                        and your credit/debit card number will not be stored in any part of our system.
                    </p>

                    <label>First 6 Digits of Your Alliance Bank Credit / Debit Card Number</label>
                    <input type="text" name="cardNumber" data-vv-validate-on="blur" data-vv-as="card number"
                        placeholder="First 6 Digits of Alliance Bank Credit / Debit Card Number"
                        v-model="value.firstSixDigitCardNumber" v-validate="'six_digits_number'" maxlength="6" :class="{
                            'form-control': true,
                            'is-invalid': validationErrors.has('cardNumber')
                        }">
                    <div v-show="validationErrors.has('cardNumber')" class="invalid-feedback">
                        {{ validationErrors.first('cardNumber') }}
                    </div>

                </div>
            </div>
        </form>
    </div>
</template>

<script>
import {
    Validator
} from 'vee-validate';
import identificationTypes from '@/config/identificationTypes';
import designations from '@/config/designations';
import { VueMaskDirective } from 'v-mask';

export default {
    'name': 'RegisterUserComponent',
    'directives': {
        'mask': VueMaskDirective
    },
    'props': {
        'value': Object,
        'emailReadonly': {
            'type': Boolean,
            'default': false
        },
        'emailAddressDisplay': {
            'type': String,
            'default': null
        },
        'registrationType': {
            'type': Number,
            'default': 1
        }
    },
    'computed': {
        identificationTypeValidation () {
            let minIdentificationType = this.identificationTypes[0].value;
            let maxIdentificationType = this.identificationTypes[this.identificationTypes.length - 1].value;

            return `required|between:${minIdentificationType},${maxIdentificationType}`;
        }
    },
    mounted () {
        const dict = {
            'custom': {
                'gender': {
                    'between': 'Gender is required.'
                },
                'identificationType': {
                    'between': 'Identification type is required.'
                }
            }
        };
        Validator.localize('en', dict);
        this.$validator.localize('en', dict);

        if (!this.value.identificationType && this.identificationTypes.length > 0) {
            this.value.identificationType = this.identificationTypes[0].value;
        }

        this.$validator.extend(
            'six_digits_number', {
                'getMessage': field => 'Please enter a valid 6 digit number.',
                'validate': (value) => {
                    if (!value) return true;
                    // split and validate each character must be a digit
                    // length must be 6
                    if (value.length < 6) return false;

                    // split and check each character
                    let characters = value.split('');
                    for (let i = 0; i < characters.length; i++) {
                        if (isNaN(characters[i])) return false;
                    }

                    return true;
                }
            });
    },
    data () {
        return {
            identificationTypes,
            designations
        };
    },
    'methods': {
        validate () {
            return this.$validator.validateAll();
        }
    }
};

</script>
